<template>
  <div class="tab" :class="{ active: tab.active, disabled: tab.disabled }">
    {{ $t(tab.label) }}
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { TabType } from "./types"

export default defineComponent({
  name: "TabsComponent",
  props: {
    tab: {
      type: Object as PropType<TabType<string | number>>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.tab {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 16px;
  gap: 10px;
  cursor: pointer;

  font-family: Montserrat;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.4px;
  border-radius: 10px;
  text-align: center;
  z-index: 1;
  color: rgba(255, 255, 255, 0.8);
  text-wrap: nowrap;

  &.active,
  &:hover {
    background: var(--text-gradient);
    font-weight: 600;
    line-height: 20px;
    color: #ffffff;
  }

  &.disabled {
    cursor: unset;
    pointer-events: none;
  }
}
</style>
